import CloseActionButton from '../../../components/kit/action-button/CloseActionButton';
import Button from '../../../components/kit/button/Button';
import Text from '../../../components/kit/text/Text';
import styles from './ThankYouScreen.module.css';

type ThankYouScreenProps = {
  isVisible: boolean;
  onClose: () => void;
};

const ThankYouScreen = ({ isVisible, onClose }: ThankYouScreenProps) => {
  return (
    <div className={isVisible ? styles.wrapper : styles.hidden}>
      <div className={styles.header}>
        <CloseActionButton onClose={onClose} />
      </div>
      <div className={styles.content}>
        <img src='images/check-icon.svg' style={{ width: '80px' }} alt='' />
        <Text weight='bold' size='x-large' tag='h1'>
          Thank you!
        </Text>
      </div>
      <div className={styles.footer}>
        <Button type='primary' width='full-width' onClick={onClose}>
          Enter Vydura Buddy
        </Button>
      </div>
    </div>
  );
};

export default ThankYouScreen;
